export type KpiTrend = 'POSITIVE' | 'NEGATIVE' | 'STABLE';

export interface Kpi {
  pourcentage: number;
  tendance: KpiTrend;
  realise: number;
  total: number;
}

export interface Kpis {
  numeroSemaine: number;
  saisieFilEau: Kpi;
  tauxOtPlanifiesRealises: Kpi;
  tauxRemplissageAgenda: Kpi;
}

export class KpiFilter {
  constructor(
    public annee: number,
    public semaine: number
  ) {}

  public compareTo(other: KpiFilter): boolean {
    return other && other.annee === this.annee && other.semaine === this.semaine;
  }
}

export function createKpis(
  numeroSemaine: number,
  saisieFilEau: Kpi,
  tauxOtPlanifiesRealises: Kpi,
  tauxRemplissageAgenda: Kpi
): Kpis {
  return {
    numeroSemaine: numeroSemaine,
    saisieFilEau: saisieFilEau,
    tauxOtPlanifiesRealises: tauxOtPlanifiesRealises,
    tauxRemplissageAgenda: tauxRemplissageAgenda,
  };
}

export function createKpi(pourcentage: number, tendance: KpiTrend, realise: number, total: number): Kpi {
  return {
    pourcentage: pourcentage,
    tendance: tendance,
    realise: realise,
    total: total,
  };
}
